<template>
  <v-container>
    <v-layout align-center justify-center fill-height>
      <v-flex xs12 sm8 md6 lg5 xl4>
        <v-card>
          <v-card-title></v-card-title>
          <v-card-text>
            <v-form v-model="valid">
              <v-layout justify-space-between wrap>
                <v-flex xs6></v-flex>
                <v-flex xs2></v-flex>
                <v-flex xs3></v-flex>
                <v-flex xs12></v-flex>
                <v-flex xs12></v-flex>
                <v-flex xs12></v-flex>
              </v-layout>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              text
              color="primary"
              :disabled="!valid"
              @click="connect"
              :loading="loading"
            >
              <v-icon>arrow_forward</v-icon>连接
              <template #loader>
                <span>连接中...</span>
              </template>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { version } from "../../../../package.json";
import CryptoJS from "crypto-js";

export default {
  beforeRouteEnter(to, from, next) {
    next(async (vm) => {
      let token = vm.$store.state.query.token;
      vm.$store.commit("isLoggedOut", true);
      if (!token) return;

      vm.$socket.emit("autofillform", token, (response) => {
        if (response.host) {
          vm.form.host = response.host;
          vm.form.queryport = response.queryport;
          vm.form.ssh = response.protocol === "ssh" ? true : false;
          vm.form.username = response.username;
          vm.form.password = response.password;
        } else {
          vm.$store.dispatch("removeToken");
          vm.$toast.error(response);
        }
      });
    });
  },
  data() {
    return {
      panel: [true],
      valid: false,
      loading: false,
      rules: {
        required: (value) => !!value || "Required.",
      },
      // 加密配置（必须与后端完全一致）
      encryptConfig: {
        key: CryptoJS.enc.Utf8.parse("Rj75qK2cHtSLRnF2"), // 16字节密钥（AES-128）
        iv: CryptoJS.enc.Utf8.parse("pVgfCDrSdKSSfgAA")    // 16字节初始向量
      },
      form: {
        host: "",
        queryport: 10011,
        ssh: false,
        username: "serveradmin",
        password: "bW2xs5U1q8Z7WgT",
      },
      appVersion: version,
    };
  },
  computed: {
    rememberLogin: {
      set(value) {
        this.$store.commit("setRememberLogin", value);
      },
      get() {
        return this.$store.state.settings.rememberLogin;
      },
    },
  },
  mounted() {
    const decryptSuccess = this.readAndDecryptUrlParams();
    if (decryptSuccess) {
      this.$nextTick(() => {
        this.valid = true;
        this.connect();
      });
    } else {
      this.valid = false;
      this.$toast.error("已登出");
    }
  },
  methods: {
    // 读取URL参数→URL安全解码→AES解密（核心修改：新增解码步骤）
    readAndDecryptUrlParams() {
      const params = new URLSearchParams(window.location.search);
      // 1. 获取URL中的加密参数（可能包含转义后的特殊字符）
      let encryptedHost = params.get('host') || '';
      let encryptedPort = params.get('port') || '';

      // 检查参数是否存在
      if (!encryptedHost || !encryptedPort) {
        console.error("缺少host或port参数");
        return false;
      }

      try {
        // 2. URL安全解码：还原Base64中的特殊字符（后端需对应编码）
        // 后端加密后需执行：strtr(base64_encode($data), '+/', '-_') 并去除末尾=
        encryptedHost = encryptedHost.replace(/-/g, '+').replace(/_/g, '/');
        encryptedPort = encryptedPort.replace(/-/g, '+').replace(/_/g, '/');

        // 3. 补全Base64缺失的=（Base64要求长度为4的倍数）
        const padHost = encryptedHost.length % 4;
        if (padHost) encryptedHost += '='.repeat(4 - padHost);
        const padPort = encryptedPort.length % 4;
        if (padPort) encryptedPort += '='.repeat(4 - padPort);

        // 4. 强制AES解密
        const decryptedHost = this.aesDecrypt(encryptedHost);
        const decryptedPort = this.aesDecrypt(encryptedPort);

        if (!decryptedHost || !decryptedPort) {
          throw new Error("解密结果为空");
        }

        this.form.host = decryptedHost;
        this.form.queryport = Number(decryptedPort);
        return true;
      } catch (err) {
        console.error("参数解码/解密失败：", err.message);
        return false;
      }
    },

    // AES解密（保持不变）
    aesDecrypt(encryptedData) {
      const { key, iv } = this.encryptConfig;
      try {
        const decrypted = CryptoJS.AES.decrypt(
          encryptedData,
          key,
          {
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
          }
        );
        const result = decrypted.toString(CryptoJS.enc.Utf8);
        if (!result) throw new Error("结果无效");
        return result;
      } catch (err) {
        throw new Error(`AES解密失败：${err.message}`);
      }
    },

    connectTeamSpeak(credentials) {
      return this.$TeamSpeak.connect(credentials);
    },

    async connect() {
      this.loading = true;
      try {
        let { token } = await this.connectTeamSpeak({
          host: this.form.host,
          queryport: this.form.queryport,
          protocol: this.form.ssh ? "ssh" : "raw",
          username: this.form.username,
          password: this.form.password,
        });
        this.$store.dispatch("saveToken", token);
        this.$store.commit("isConnected", true);
        this.$store.commit("isLoggedOut", false);
        this.$router.push({ name: "servers" });
      } catch (err) {
        this.$toast.error(err.message);
      } finally {
        this.loading = false;
      }
    },
  },
  watch: {
    "form.ssh"(ssh) {
      this.form.queryport = ssh ? 10022 : 10011;
    },
  },
};
</script>

<style>
.v-expansion-panel__header {
  padding: 0 !important;
}
</style>